import './style.sass';

import parser from 'html-react-parser';
import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CommonSmallTitle from '../../../common-components/common-small-title';

const media = [
    {
        title: 'В&nbsp;России создали искусственный интеллект для редактирования сочинений',
        subtitle: 'Фонд НТИ',
        icon: '/images/pic/upgreat/media/media1.png',
        link: 'https://nti.fund/about/news/?ELEMENT_ID=3385',
    },
    {
        title: 'Нейросеть начнет проверять сочинения российских школьников',
        subtitle: 'Snob.ru',
        icon: '/images/pic/upgreat/media/media2.png',
        link: 'https://snob.ru/news/nejroset-nachnet-proveryat-sochineniya-rossijskih-shkolnikov/',
    },
    {
        title: 'С&nbsp;февраля 2023 года сочинения российских школьников начнут проверять при помощи нейросетей',
        subtitle: 'Habr.com',
        icon: '/images/pic/upgreat/media/media3.png',
        link: 'https://habr.com/ru/news/t/706336/',
    },
    {
        title: 'Нейросеть начнет в&nbsp;пилотном режиме проверять сочинения школьников',
        subtitle: 'Газета.ru',
        icon: '/images/pic/upgreat/media/media4.png',
        link: 'https://www.gazeta.ru/tech/news/2022/12/19/19302691.shtml',
    },
    {
        title: 'Нейросети займутся проверкой школьных сочинений',
        subtitle: 'Москва24',
        icon: '/images/pic/upgreat/media/media5.png',
        link: 'https://www.m24.ru/news/tehnologii/19122022/532853?utm_source=CopyBuf',
    },
    {
        title: 'Сочинения российских школьников будет проверять нейронная сеть',
        subtitle: 'Rusbase',
        icon: '/images/pic/upgreat/media/media6.png',
        link: 'https://rb.ru/news/sochineniya-nejroset/',
    },
    {
        title: 'В&nbsp;2023 году запустят пилотный проект по&nbsp;проверке школьных сочинений нейросетью',
        subtitle: 'Новые Известия',
        icon: '/images/pic/upgreat/media/media7.png',
        link: 'https://newizv.ru/news/2022-12-19/v-2023-godu-zapustyat-pilotnyy-proekt-po-proverke-shkolnyh-sochineniy-neyrosetyu-374250',
    },
];

function AboutUs() {
    return (
        <FullWrapper className="upgrade-about-us">
            <div className="upgrade-about-us__inner">
                <CommonSmallTitle>СМИ о проекте:</CommonSmallTitle>
                {media.map(data => (
                    <a
                        key={data}
                        href={data.link}
                        target="_blank"
                        className="upgrade-about-us__wrapper"
                        rel="noopener noreferrer nofollow"
                    >
                        <img className="upgrade-about-us__icon" src={data.icon} alt="icon" />
                        <div className="upgrade-about-us__info">
                            <div className="upgrade-about-us__info-title">{parser(data.title)}</div>
                            <div className="upgrade-about-us__info-subtitle">{data.subtitle}</div>
                        </div>
                    </a>
                ))}
            </div>
        </FullWrapper>
    );
}

export default AboutUs;
